
/* eslint-disable one-var */

(function($) {
  $.fn.cascader = function(options) {
    var defaults = {
      cascaderId: -1,
      fieldId: -1,
      allowMiddle: false,
      reportEditor: null,
      selectRange: null
    }
    var opts = $.extend(defaults, options)

    var _this = this, cascader_list = _this.find('.cascader_list').eq(0)
    var level = 0, selJson = [], data = [], overTimer

    cascader_list.delegate('li.item', 'click', function(event) {
      $(this).addClass('loading')
      clearTimeout(overTimer)
      var parent_index = $(this).parent().index()
      $(this).addClass('on').siblings().removeClass('on')
      level = parent_index
      _this.find('.cascader_list_ul').eq(level).nextAll().remove()
      if ($(this).hasClass('lastchild') || $(event.target).hasClass('can-select')) {
        var selectionData = {}
        var selectionValue = $(cascader_list.find('li.on')).last().attr('data-value')
        var currentSelection = getValue()
        currentSelection.pop()
        var currentData = opts.reportEditor.handleCascaderData(opts.fieldId, currentSelection)
        selectionData = currentData.filter(row => {
          return row.value == selectionValue
        })[0].rowData
        opts.reportEditor.handleCascaderSelect(opts.fieldId, opts.selectRange, selectionData)
        popClose()
      } else {
        getNextLevel(getValue())
      }

      $(this).removeClass('loading')
    })

    cascader_list.delegate('li.item', 'mouseenter', function() {
      var _thisItem = this
      // 指向时开始计时
      overTimer = setTimeout(function() {
        $(_thisItem).addClass('loading')
        if ($(_thisItem).hasClass('lastchild')) {
          return
        }
        var parent_index = $(_thisItem).parent().index()
        $(_thisItem).addClass('on').siblings().removeClass('on')
        level = parent_index
        _this.find('.cascader_list_ul').eq(level).nextAll().remove()
        getNextLevel(getValue())
        $(_thisItem).removeClass('loading')
      }, 300)
    })

    cascader_list.delegate('li.item', 'mouseleave', function() {
      // 离开时结束计时
      clearTimeout(overTimer)
    })

    function getNextLevel(selections) {
      data = opts.reportEditor.handleCascaderData(opts.fieldId, selections)
      createEl(data)
    }

    function createEl(data) {
      /*  点击非最后一个子级 */
      createUl(data)
      popOpen(cascader_list)
    }

    function getMP (e) {
      e = e || window.event

      return {

        x: e.pageX || e.clientX + (document.documentElement.scrollLeft || document.body.scrollLeft),

        y: e.pageY || e.clientY + (document.documentElement.scrollTop || document.body.scrollTop)

      }
    }
    function createUl(data) {
      var liArr = [], ul = $('<ul class="cascader_list_ul"></ul>')
      var replcaeAll = (str) => {
        return isNaN(str) ? str.replace(/"/g, '&quot;') : str
      }
      $.each(data, function(i, item) {
        var lastClass = ''
        var selectionClass = 'cascader-label '
        if (item.lastLevel) {
          lastClass = 'lastchild'
        }
        if (item.canSelect && opts.allowMiddle) {
          selectionClass += 'can-select'
        }
        liArr.push(`<li data-label="${replcaeAll(item.label)}" data-value="${replcaeAll(item.value)}" class="item workfine cascader-item ${lastClass}"><span class="${selectionClass}" title="${item.label}">${item.label}</span></li>`)
      })
      if (liArr.length === 0) {
        ul.append($('<span class="cascader-no-data">无数据</span>'))
      } else {
        ul.append(liArr.join(''))
      }
      cascader_list.append(ul)
    }

    function getValue() {
      selJson = []
      cascader_list.find('li.on').each(function() {
        var label = $(this).attr('data-label'),
          value = $(this).attr('data-value')
        selJson.push({ 'value': value, 'label': label })
      })
      return selJson
    }

    function popClose() {
      _this.removeClass('open')
      _this.find('.cascader_list').undelegate()
      _this.find('.cascader_list').addClass('hid')
      _this.find('.cascader_list').empty()
    }

    function popOpen() {
      _this.addClass('open')
      // 添加位置处理
      try {
        const position = getMP()
        var css = {
          'position': 'fixed',
          'z-index': 9999,
          'left': position.x,
          'top': position.y
        }
        cascader_list.css(css)
      } catch (ex) { }
      cascader_list.removeClass('hid')
    }

    if (opts.fieldId >= 0) {
      opts.reportEditor.initCascaderData(opts.fieldId).then(result => {
        data = result
        createUl(data)
        popOpen()
        // return getValue
      })
    }
  }
// eslint-disable-next-line no-undef
})(jQuery)
